

export default {
    /** 
     * Permite obtener la lista de NUCs asociados al usuario, junto con sus estados (activo/inactivo) y preferencias relacionadas.
     * @example
     * GET /api/buzon/nucs?idUsuario=1&currentPage=1&pageSize=5
     */
    GET_BUZON_NUC_PREFERENCE: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/nucs`,
    /** 
     * Permite obtener la lista de notificaciones judiciales asociadas a un NUC específico.
     * @example
     * GET /api/buzon/notificaciones?idUsuario=1&currentPage=1&pageSize=3
     */
    GET_BUZON_NUC_NOTIFICATIONS: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/notificaciones`,
    /** 
     * Activa uno o más NUCs por sus ids de caso
     * @example
     * POST /api/buzon/solicitud-activar
     */
    ACTIVATE_NUCS: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/solicitud-activar`,
    /** 
     * Desactiva uno o más NUCs por sus ids de caso 
     * @example
     * POST /api/buzon/solicitud-inactivar
     */
    DEACTIVATE_NUCS: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/solicitud-inactivar`,
    /** 
     * Retorna todos los IDs de NUCs del usuario (sin paginación) para selección cross-page
     * @example
     * GET /api/buzon/nucs/ids?idUsuario=1
     */
    GET_ALL_NUC_IDS: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/nucs/ids`,
    /** 
     * Cancela una solicitud pendiente (firma o deshabilitación)
     * @example
     * POST /api/buzon/cancelar-solicitud
     */
    CANCEL_SOLICITUD: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/cancelar-solicitud`,
    /**
     * Registra la visualización de una notificación en la bitácora
     * @example
     * POST /api/buzon/bitacora-visualizacion
     */
    REGISTRAR_VISUALIZACION: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/bitacora-visualizacion`,
    /**
     * Registra una acción genérica sobre una notificación (ABRIR_NOTIFICACION, VISUALIZAR_DOCUMENTO, DESCARGAR_DOCUMENTO)
     * @example
     * POST /api/buzon/bitacora-accion
     */
    REGISTRAR_ACCION: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/bitacora-accion`,
    /**
     * Retorna el conteo de notificaciones judiciales no leídas (`count`) y su desglose por tipo (`indicadores`)
     * @example
     * GET /api/buzon/notificaciones/no-leidas?idUsuario=1
     */
    GET_UNREAD_COUNT: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/notificaciones/no-leidas`,
    /**
     * Solicitud de rehabilitación de NUCs previamente deshabilitados
     * @example
     * POST /api/buzon/solicitud-rehabilitar
     */
    REACTIVATE_NUCS: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/solicitud-rehabilitar`,
    /**
     * Devuelve las categorías de tribunal (instancias) disponibles para uno o varios casos
     * @example
     * GET /api/buzon/instancias-disponibles?idsCasos=1&idsCasos=2
     */
    GET_INSTANCIAS_DISPONIBLES: `${import.meta.env.VITE_API_CONSULTAS_AD}/api/buzon/instancias-disponibles`,
}